export default __webpack_public_path__ + "static/media/churen.12afd390.jpg";